export const init = (context = document) => {
  // expand / collapse another element
  const toggleExpand = (toggle, targets) => {
    [...targets].forEach(target => {
      const isExpanded = target.dataset.visible;
      if (isExpanded) {
        target.removeAttribute('data-visible');
      } else {
        target.setAttribute('data-visible', true);
      }
      toggle.setAttribute('aria-expanded', !isExpanded);
    });
  };

  // swap text
  const toggleText = toggle => {
    const element = toggle;
    const previousText = element.innerText;
    element.textContent = element.dataset.toggleText;
    element.setAttribute('data-toggle-text', previousText);
  };

  // toggle body scroll lock
  const toggleScrollLock = () => {
    document.querySelector('body').toggleAttribute('data-scroll-lock');
  };

  const toggles = context.querySelectorAll('[data-toggle]');
  [...toggles].forEach(toggle => {
    if (toggle.hasAttribute('data-toggle-expand')) {
      toggle.addEventListener(
        'click',
        () => {
          toggleExpand(toggle, context.querySelectorAll(toggle.dataset.toggleExpand));
          if (toggle.hasAttribute('data-toggle-hide')) {
            toggle.setAttribute('style', 'display:none');
          }
        },
        false
      );
    }
    if (toggle.hasAttribute('data-toggle-text')) {
      toggle.addEventListener(
        'click',
        () => {
          toggleText(toggle);
        },
        false
      );
    }
    if (toggle.hasAttribute('data-toggle-scroll-lock')) {
      toggle.addEventListener(
        'click',
        () => {
          toggleScrollLock();
        },
        false
      );
    }
  });
};
